import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/wanghong', label: '网红爆料' },
    { to: '/category/mingxing', label: '明星黑料' },
    { to: '/category/shipin', label: '反差视频' },
    { to: '/category/shehui', label: '社会大瓜' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-100/95 backdrop-blur-xl border-b border-background-300/40'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3 group shrink-0">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-fire-fill text-primary-500 text-2xl"></i>
            </div>
            <span className="font-heading text-xl text-foreground-50 tracking-wider group-hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
              暗网吃瓜
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.to
                || (link.to !== '/' && location.pathname.startsWith(link.to));
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`px-4 py-2 rounded-lg text-sm transition-all duration-200 whitespace-nowrap ${
                    isActive
                      ? 'text-primary-500 bg-primary-500/10'
                      : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-200/50'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          <div className="flex items-center gap-3">
            <a
              href="#download"
              className="hidden md:flex items-center gap-2 px-5 py-2 bg-primary-500 text-background-950 font-medium text-sm rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-2-line text-base w-4 h-4 flex items-center justify-center"></i>
              <span>下载APP</span>
            </a>
            <button
              onClick={() => setIsMobileOpen(!isMobileOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-300 hover:text-foreground-50 hover:bg-background-200/50 transition-colors cursor-pointer"
              aria-label="菜单"
            >
              <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-100/98 backdrop-blur-xl border-t border-background-300/30">
          <div className="px-4 py-4 flex flex-col gap-2">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.to
                || (link.to !== '/' && location.pathname.startsWith(link.to));
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`px-4 py-3 rounded-lg text-sm transition-all duration-200 ${
                    isActive
                      ? 'text-primary-500 bg-primary-500/10'
                      : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-200/50'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <a
              href="#download"
              className="flex items-center justify-center gap-2 px-5 py-3 mt-2 bg-primary-500 text-background-950 font-medium text-sm rounded-full hover:bg-primary-600 transition-all duration-200 cursor-pointer"
            >
              <i className="ri-download-2-line text-base w-4 h-4 flex items-center justify-center"></i>
              <span>下载暗网吃瓜APP</span>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}